jQuery(document).ready(function ($) {
    if ($('.section-video').length) {
        $(".section-video .video-container").click(function() {
            $(this).addClass('video-playing');
          
            var videoSrc = $('.video-iframe').attr('src');
            $('.video-iframe').attr('src', videoSrc + '&autoplay=1&mute=1');
        });
    }
  
    if ($('.trp-language-switcher').length) {
        $(window).on('load', function () {
            setTimeout(function () {
                var current_lang = $('.trp-language-switcher > div > a.trp-ls-disabled-language').attr('title');
                if (current_lang == 'English') {
                    $('.trp-language-switcher > div > a.trp-ls-disabled-language').text('EN');
                    $('.trp-language-switcher > div > a.trp-ls-disabled-language + a').text('FR');
                    $('.trp-language-switcher > div > a.trp-ls-disabled-language + a').attr('title', 'French');
                }
            }, 2000)
        });
    }

    //screenshot
    function saveAs(uri, filename) {
        var link = document.createElement("a");
        if (typeof link.download === "string") {
            link.href = uri;
            link.download = filename;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
        } else {
            window.open(uri);
        }
    };

    if ($('.screenshot_button').length) {
        $('.screenshot_button').on('click', function(e) {
            e.preventDefault();

            html2canvas($("#collection_configuration"), {
                onrendered: function (canvas) {
                    saveAs(canvas.toDataURL(), "screenshot.jpg");
                }
            });
        });
    }

    //show Symbolique des lettres
    if ($('.trouver-mes-initiales-hebraique').length) {
        $('.trouver-mes-initiales-hebraique').on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('btn-active')) {
                return true;
            } else {
                $('.symbolique-des-lettres').removeClass('btn-active');
                $(this).addClass('btn-active');

                $('#symbolique-des-lettres').hide();
                $('#trouver-mes-initiales-hebraique').show();
            }
        });
    }

    if ($('.symbolique-des-lettres').length) {
        $('.symbolique-des-lettres').on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('btn-active')) {
                return true;
            } else {
                $('.trouver-mes-initiales-hebraique').removeClass('btn-active');
                $(this).addClass('btn-active');

                $('#trouver-mes-initiales-hebraique').hide();
                $('#symbolique-des-lettres').show();
            }
        });
    }

    // product cat masonry
    if ($('.product-cat-masonry').length) {
        $('.product-cat-masonry .wd-gallery-item').each(function () {
            var item = $(this);
            var title = item.children('a').children('img').attr('alt');

            $('<div class="item-meta-wrap"><h3 class="wd-entities-title">' + title + '</h3><p class="elementor-button-link elementor-button elementor-size-sm">Symbolique</p></div>').appendTo(item.children('a'));
        });
    }

    // change languge
    if ($('.language').length) {
        if ($('html')[0].lang == 'fr-FR') {
            $('.language .option-language .en').removeClass('active');
            $('.language .option-language .fr').addClass('active');
        } else {
            $('.language .option-language .en').addClass('active');
            $('.language .option-language .fr').removeClass('active');
        }

        $('.language .option-language > div').on('click', function(e) {
            e.preventDefault();

            var lan = $(this).attr('data-lan');

            if ($(this).hasClass('active')) {
                return true;
            } else {
                $('.language .option-language > div').removeClass('active');
                $(this).addClass('active');

                if (lan == 'fr') {
                    $('.gtranslate_wrapper a[data-gt-lang="fr"]').click();
                    console.log($('.gtranslate_wrapper a[data-gt-lang="fr"]').length);

                    $('.language .result-language p').text('FR / €');
                } else {
                    $('.gtranslate_wrapper a[data-gt-lang="en"]').click();
                    console.log($('.gtranslate_wrapper a[data-gt-lang="fr"]').length);

                    $('.language .result-language p').text('EN / $');
                }
            }
        });
    }

    // page collection options
    if ($('.page-template-page-collection').length) {
        // carousel option
        $(window).on('load', function () {
            $('.tc-extra-product-options ul.tc-carousel-option').each(function () {
                var item = $(this);

                item.slick({
                    dots: false,
                    variableWidth: true,
                    infinite: false,
                    autoplay: false,
                    arrows: true,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    prevArrow: '<div class="slick-prev slick-arrow" style=""><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 11L1 6L6 1" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
                    nextArrow: '<div class="slick-next slick-arrow" style=""><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L1 11" stroke="ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
                });
            });
        });

        // step by step event click prew
        $('.tc-step-by-step .tc-prew-step').on('click', function (e) {
            e.preventDefault();

            var cStep;
            cStep = $(this).attr('data-current-step');
            cStep = parseInt(cStep)
            pStep = cStep - 1;

            if (pStep == 0) {
                return false;
            } else {
                $('.tc-step-by-step .tc-prew-step').attr('data-current-step', pStep);
                $('.tc-step-by-step .tc-next-step').attr('data-current-step', pStep);
                $('.tc-step-by-step .current-step').text(pStep);
                $('.tc-add-to-cart').hide();
                $('.social-share-buttons').hide();

                var title_step = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + pStep + ':not(.tc-hidden)').find('.tm-section-label').text();
                $('.tc-label-step .label-step').text(title_step);
                $('.tc-label-step .current-step').text(pStep);

                $('.tc-step-by-step .tc-next-step').removeClass('disable');
                $('.tc-step-by-step .tc-step-by-step-wrap').css('color', '#B4A6A6');

                if (pStep === 1) {
                    $(this).addClass('disable');
                    
                    $('.tc-select-type-de-bijou').slideUp();
                    $('.tc-select-collection').slideDown();

                    var collection_name = $('.custom-single-product-page form.cart.tc-active .tc-select-collection .btn-select-collection.tc-active').find('.collection-title').text();
                    $('.custom-single-product-page .tc-step-by-step .tc-step-by-step-wrap .name-option-selected').text(' : ' + collection_name);
                } else if (pStep === 2) {
                    var collection_name = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + pStep + ':not(.tc-hidden)').find('li.tc-active .tc-name-option').text();
                    $('.custom-single-product-page .tc-step-by-step .tc-step-by-step-wrap .name-option-selected').text(' : ' + collection_name);

                    $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + cStep).slideUp();
                    $('.tc-select-type-de-bijou').slideDown();
                } else {
                    $(this).removeClass('disable');

                    $('.custom-single-product-page .tc-step-by-step .tc-step-by-step-wrap .name-option-selected').text('');

                    $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + cStep).slideUp();
                    $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + pStep).slideDown();
                }
            }
        });

        // step by step event click next
        $('.tc-step-by-step .tc-next-step').on('click', function (e) {
            e.preventDefault();

            var totalStep = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-css:not(.tc-hidden)').length;
            var cStep;
            cStep = $(this).attr('data-current-step');
            cStep = parseInt(cStep)
            nStep = cStep + 1;

            if (nStep > totalStep) {
                return false;
            } else {
                var all_selected = true;

                $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + cStep).find('div.tm-cell:not(.tc-hidden)').each(function () {
                    var selected = false;
                    var div_active = $(this);
                    div_active.find('li.tmcp-field-wrap').each(function () {
                        if ($(this).hasClass('tc-active')) {
                            selected = true;
                        }
                    });

                    if (selected === false) {
                        all_selected = false;
                    }
                });

                if (all_selected === false) {
                    return false;
                }

                $('.tc-step-by-step .tc-prew-step').attr('data-current-step', nStep);
                $('.tc-step-by-step .tc-next-step').attr('data-current-step', nStep);
                $('.tc-step-by-step .current-step').text(nStep);

                var title_step = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + nStep + ':not(.tc-hidden)').find('.tm-section-label').text();
                $('.tc-label-step .label-step').text(title_step);
                $('.tc-label-step .current-step').text(nStep);

                $('.tc-step-by-step .tc-prew-step').removeClass('disable');
                if (nStep === totalStep) {
                    $(this).addClass('disable');
                    $('.tc-add-to-cart').show();
                    $('.social-share-buttons').show();
                    $('.tc-step-by-step .tc-step-by-step-wrap').css('color', '#707070');
                } else {
                    $(this).removeClass('disable');
                }

                if (cStep === 1) {
                    $('.tc-select-collection').slideUp();
                    $('.tc-select-type-de-bijou').slideDown();

                    var collection_name = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + nStep + ':not(.tc-hidden)').find('li.tc-active .tc-name-option').text();
                    $('.custom-single-product-page .tc-step-by-step .tc-step-by-step-wrap .name-option-selected').text(' : ' + collection_name);
                } else if(cStep === 2) {
                    $('.custom-single-product-page .tc-step-by-step .tc-step-by-step-wrap .name-option-selected').text('');

                    $('.tc-select-type-de-bijou').slideUp();
                    $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + nStep).slideDown();
                } else {
                    $('.custom-single-product-page .tc-step-by-step .tc-step-by-step-wrap .name-option-selected').text('');

                    $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + cStep).slideUp();
                    $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-step' + nStep).slideDown();
                }
            }
        });

        // select collection
        $('.tc-select-collection .btn-select-collection').on('click', function (e) {
            e.preventDefault();

            var collection = $(this).attr('data-collection');
            var collection_name = $(this).children('.radio_image_label').text();

            $('.custom-single-product-page .row-images .image-wrap').attr('data-collection', collection);

            $('.tc-select-collection .btn-select-collection').removeClass('tc-active');
            $('.tc-select-collection .btn-select-collection[data-collection=' + collection + ']').addClass('tc-active');

            $('.custom-single-product-page .tc-select-collection .tc-selected-option').text(collection_name);

            $('.custom-single-product-page .tc-step-by-step .tc-step-by-step-wrap .name-option-selected').text(' : ' + collection_name);

            $('.custom-single-product-page').attr('data-collection', collection);

            $('.tc-extra-product-options ul.tc-carousel-option').each(function () {
                var item = $(this);

                if (!item.hasClass('slick-slider')) {
                    item.slick({
                        dots: false,
                        variableWidth: true,
                        infinite: false,
                        autoplay: false,
                        arrows: true,
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        prevArrow: '<div class="slick-prev slick-arrow" style=""><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 11L1 6L6 1" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
                        nextArrow: '<div class="slick-next slick-arrow" style=""><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L1 11" stroke="ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
                    });
                }
            });

            $('.custom-single-product-page .tc-select-type-de-bijou .btn-select-type-de-bijou').hide();
            $('.custom-single-product-page .tc-select-type-de-bijou .btn-select-type-de-bijou[data-collection=' + collection + ']').show();

            var collection_type = $('.custom-single-product-page .tc-select-type-de-bijou').find('.btn-select-type-de-bijou.tc-active[data-collection=' + collection + ']').attr('data-type-de-bijou');
            $('.custom-single-product-page .row-options .product-form form.cart').removeClass('tc-active');
            $('.custom-single-product-page .row-options .product-form form.cart-' + collection_type).addClass('tc-active');

            var totalStep = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-css:not(.tc-hidden)').length;
            $('.tc-step-by-step .total-step').text(totalStep);
            $('.tc-label-step .total-step').text(totalStep);

            // add class jewel
            var selected_label = $('.custom-single-product-page form.cart.tc-active .section-panel-step2').find('li.tc-active').find('.tc-name-option').text();
            $('.custom-single-product-page .row-images .image-wrap').removeClass('bracelet').removeClass('collier').addClass(selected_label.toLowerCase());

            // add image
            $('.custom-single-product-page .row-images img.attachment-main').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-accroche').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-jewelry').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-jewelry-droit').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-jewelry-gauche').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-rubi').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-rubi-droit').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-rubi-gauche').attr('src', '');

            var option_size = false;
            var collection_form = $('.custom-single-product-page').find('form.cart.tc-active');
            var extra_product_options = collection_form.find('.tc-extra-product-options');
            extra_product_options.find('.section-panel-css:not(.tc-hidden)').each(function () {
                var section = $(this);

                // add image main
                var tm_cell = section.find('div.tm-cell:not(.tm-row):not(.tc-hidden):not(.tc-not-change-product-img)');
                tm_cell.each(function () {
                    var img_main = $(this).find('li.tc-active').find('input.tmcp-field').attr('data-imagep');
                    if (img_main && img_main !== '') {
                        $('.custom-single-product-page .row-images img.attachment-main').attr('src', img_main);
                    }
                });

                // add image option
                // accroche
                var div_chain_type = section.find('div.tc-chain-type-option:not(.tc-hidden)');
                if (div_chain_type.length > 0) {
                    var li_chain_type = div_chain_type.find('li.tc-active');
                    var chain_type = li_chain_type.attr('data-rd_loop_gallery');

                    if (chain_type === '1' || chain_type === '2') {
                        var div_accroche = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-css:not(.tc-hidden)').find('div.tc-accroche-option:not(.tc-hidden)');
                        if (div_accroche.length > 0) {
                            var li_accroche = div_accroche.find('li.tc-active');
                            var img_accroche = li_accroche.find('input.tc-accroche-option').attr('data-imagep');
                            $('.custom-single-product-page .row-images img.attachment-accroche').attr('src', img_accroche).css('display', 'block');
                        } else {
                            $('.custom-single-product-page .row-images img.attachment-accroche').css('display', 'none');
                        }
                    } else {
                        $('.custom-single-product-page .row-images img.attachment-accroche').css('display', 'none');
                    }
                }

                // jewelry
                var div_jewelry = section.find('div.tc-jewelry-option:not(.tc-hidden)');
                if (div_jewelry.length > 0) {
                    var li_jewelry = div_jewelry.find('li.tc-active');
                    var img_jewelry = li_jewelry.find('input.tc-jewelry-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-jewelry').attr('src', img_jewelry);

                    if (div_jewelry.hasClass('tc-not-change-product-img')) {
                        var img_jewelry_accroche = li_jewelry.find('input.tc-jewelry-option').attr('data-imagep');
                        $('.custom-single-product-page .row-images img.attachment-accroche').attr('src', img_jewelry_accroche);
                    }
                }

                // jewelry droit
                var div_jewelry_droit = section.find('div.tc-jewelry-droit-option:not(.tc-hidden)');
                if (div_jewelry_droit.length > 0) {
                    var li_jewelry_droit = div_jewelry_droit.find('li.tc-active');
                    var img_jewelry_droit = li_jewelry_droit.find('input.tc-jewelry-droit-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-jewelry-droit').attr('src', img_jewelry_droit);
                }

                // jewelry gauche
                var div_jewelry_gauche = section.find('div.tc-jewelry-gauche-option:not(.tc-hidden)');
                if (div_jewelry_gauche.length > 0) {
                    var li_jewelry_gauche = div_jewelry_gauche.find('li.tc-active');
                    var img_jewelry_gauche = li_jewelry_gauche.find('input.tc-jewelry-gauche-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-jewelry-gauche').attr('src', img_jewelry_gauche);
                }

                // rubi
                var div_rubi = section.find('div.tc-rubi-option:not(.tc-hidden):not(.tc-hidden-rubi)');
                if (div_rubi.length > 0) {
                    var li_rubi = div_rubi.find('li.tc-active');
                    var img_rubi = li_rubi.find('input.tc-rubi-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-rubi').attr('src', img_rubi);
                }

                // rubi droit
                var div_rubi_droit = section.find('div.tc-rubi-droit-option:not(.tc-hidden):not(.tc-hidden-rubi)');
                if (div_rubi_droit.length > 0) {
                    var li_rubi_droit = div_rubi_droit.find('li.tc-active');
                    var img_rubi_droit = li_rubi_droit.find('input.tc-rubi-droit-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-rubi-droit').attr('src', img_rubi_droit);
                }

                // rubi gauche
                var div_rubi_gauche = section.find('div.tc-rubi-gauche-option:not(.tc-hidden):not(.tc-hidden-rubi)');
                if (div_rubi_gauche.length > 0) {
                    var li_rubi_gauche = div_rubi_gauche.find('li.tc-active');
                    var img_rubi_gauche = li_rubi_gauche.find('input.tc-rubi-gauche-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-rubi-gauche').attr('src', img_rubi_gauche);
                }

                // size product
                var div_size_product = section.find('div.tc-size-product-option:not(.tc-hidden)');
                if (div_size_product.length > 0) {
                    option_size = true;

                    var li_size_product = div_size_product.find('li.tc-active');
                    var size_product =  li_size_product.find('input.tc-size-product-option').val();
                    var petit = 'Petit';
                    var grand = 'Grand';
                    var moyen = 'Moyen';
                    if (size_product.indexOf(petit) != -1) {
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('grand').removeClass('moyen').addClass('petit');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('grand').removeClass('moyen').addClass('petit');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('grand').removeClass('moyen').addClass('petit');
                    } else if (size_product.indexOf(grand) != -1) {
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('petit').removeClass('moyen').addClass('grand');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('petit').removeClass('moyen').addClass('grand');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('petit').removeClass('moyen').addClass('grand');
                    } else if (size_product.indexOf(moyen) != -1) {
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('grand').removeClass('petit').addClass('moyen');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('grand').removeClass('petit').addClass('moyen');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('grand').removeClass('petit').addClass('moyen');
                    } else {
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('grand').removeClass('petit').removeClass('moyen');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('grand').removeClass('petit').removeClass('moyen');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('grand').removeClass('petit').removeClass('moyen');
                    }
                }

                if (option_size === false) {
                    $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('grand').removeClass('petit').removeClass('moyen');
                    $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('grand').removeClass('petit').removeClass('moyen');
                    $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('grand').removeClass('petit').removeClass('moyen');
                }
            });
        });

        // select type de bijou
        $('.tc-select-type-de-bijou .btn-select-type-de-bijou').on('click', function (e) {
            e.preventDefault();

            var collection = $(this).attr('data-collection');
            var bijou_type = $(this).attr('data-type');
            var collection_type = $(this).attr('data-type-de-bijou');
            var collection_name = $(this).children('.radio_image_label').text();
            var product_id = $(this).attr('data-product-id');

            $('.custom-single-product-page .row-images .image-wrap').attr('data-type-de-bijou', bijou_type);

            $('.tc-select-type-de-bijou .btn-select-type-de-bijou').removeClass('tc-active');
            $('.tc-select-type-de-bijou .btn-select-type-de-bijou[data-type=' + bijou_type + ']').addClass('tc-active');

            $('.custom-single-product-page .tc-select-type-de-bijou .tc-selected-option').text(collection_name);

            $('.custom-single-product-page .tc-step-by-step .tc-step-by-step-wrap .name-option-selected').text(' : ' + collection_name);

            $('.custom-single-product-page').attr('data-collection', collection);

            $('.tc-extra-product-options ul.tc-carousel-option').each(function () {
                var item = $(this);

                if (!item.hasClass('slick-slider')) {
                    item.slick({
                        dots: false,
                        variableWidth: true,
                        infinite: false,
                        autoplay: false,
                        arrows: true,
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        prevArrow: '<div class="slick-prev slick-arrow" style=""><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 11L1 6L6 1" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
                        nextArrow: '<div class="slick-next slick-arrow" style=""><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L1 11" stroke="ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
                    });
                }
            });

            $('.custom-single-product-page .row-options .product-form form.cart').removeClass('tc-active');
            $('.custom-single-product-page .row-options .product-form form.cart-' + collection_type).addClass('tc-active');

            var totalStep = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-css:not(.tc-hidden)').length;
            $('.tc-step-by-step .total-step').text(totalStep);
            $('.tc-label-step .total-step').text(totalStep);

            // add class jewel
            var selected_label = $('.custom-single-product-page form.cart.tc-active .section-panel-step2').find('li.tc-active').find('.tc-name-option').text();
            $('.custom-single-product-page .row-images .image-wrap').removeClass('bracelet').removeClass('collier').addClass(selected_label.toLowerCase());

            // add image
            $('.custom-single-product-page .row-images img.attachment-main').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-accroche').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-jewelry').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-jewelry-droit').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-jewelry-gauche').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-rubi').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-rubi-droit').attr('src', '');
            $('.custom-single-product-page .row-images img.attachment-rubi-gauche').attr('src', '');

            var option_size = false;
            var collection_form = $('.custom-single-product-page').find('form.cart.tc-active');
            var extra_product_options = collection_form.find('.tc-extra-product-options');
            extra_product_options.find('.section-panel-css:not(.tc-hidden)').each(function () {
                var section = $(this);

                // add image main
                var tm_cell = section.find('div.tm-cell:not(.tm-row):not(.tc-hidden):not(.tc-not-change-product-img)');
                tm_cell.each(function () {
                    var img_main = $(this).find('li.tc-active').find('input.tmcp-field').attr('data-imagep');
                    if (img_main && img_main !== '') {
                        $('.custom-single-product-page .row-images img.attachment-main').attr('src', img_main);
                    }
                });

                // add image option
                // accroche
                var div_chain_type = section.find('div.tc-chain-type-option:not(.tc-hidden)');
                if (div_chain_type.length > 0) {
                    var li_chain_type = div_chain_type.find('li.tc-active');
                    var chain_type = li_chain_type.attr('data-rd_loop_gallery');

                    if (chain_type === '1' || chain_type === '2') {
                        var div_accroche = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-css:not(.tc-hidden)').find('div.tc-accroche-option:not(.tc-hidden)');
                        if (div_accroche.length > 0) {
                            var li_accroche = div_accroche.find('li.tc-active');
                            var img_accroche = li_accroche.find('input.tc-accroche-option').attr('data-imagep');
                            $('.custom-single-product-page .row-images img.attachment-accroche').attr('src', img_accroche).css('display', 'block');
                        } else {
                            $('.custom-single-product-page .row-images img.attachment-accroche').css('display', 'none');
                        }
                    } else {
                        $('.custom-single-product-page .row-images img.attachment-accroche').css('display', 'none');
                    }
                }

                // jewelry
                var div_jewelry = section.find('div.tc-jewelry-option:not(.tc-hidden)');
                if (div_jewelry.length > 0) {
                    var li_jewelry = div_jewelry.find('li.tc-active');
                    var img_jewelry = li_jewelry.find('input.tc-jewelry-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-jewelry').attr('src', img_jewelry);

                    if (div_jewelry.hasClass('tc-not-change-product-img')) {
                        var img_jewelry_accroche = li_jewelry.find('input.tc-jewelry-option').attr('data-imagep');
                        $('.custom-single-product-page .row-images img.attachment-accroche').attr('src', img_jewelry_accroche);
                    }
                }

                // jewelry droit
                var div_jewelry_droit = section.find('div.tc-jewelry-droit-option:not(.tc-hidden)');
                if (div_jewelry_droit.length > 0) {
                    var li_jewelry_droit = div_jewelry_droit.find('li.tc-active');
                    var img_jewelry_droit = li_jewelry_droit.find('input.tc-jewelry-droit-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-jewelry-droit').attr('src', img_jewelry_droit);
                }

                // jewelry gauche
                var div_jewelry_gauche = section.find('div.tc-jewelry-gauche-option:not(.tc-hidden)');
                if (div_jewelry_gauche.length > 0) {
                    var li_jewelry_gauche = div_jewelry_gauche.find('li.tc-active');
                    var img_jewelry_gauche = li_jewelry_gauche.find('input.tc-jewelry-gauche-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-jewelry-gauche').attr('src', img_jewelry_gauche);
                }

                // rubi
                var div_rubi = section.find('div.tc-rubi-option:not(.tc-hidden):not(.tc-hidden-rubi)');
                if (div_rubi.length > 0) {
                    var li_rubi = div_rubi.find('li.tc-active');
                    var img_rubi = li_rubi.find('input.tc-rubi-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-rubi').attr('src', img_rubi);
                }

                // rubi droit
                var div_rubi_droit = section.find('div.tc-rubi-droit-option:not(.tc-hidden):not(.tc-hidden-rubi)');
                if (div_rubi_droit.length > 0) {
                    var li_rubi_droit = div_rubi_droit.find('li.tc-active');
                    var img_rubi_droit = li_rubi_droit.find('input.tc-rubi-droit-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-rubi-droit').attr('src', img_rubi_droit);
                }

                // rubi gauche
                var div_rubi_gauche = section.find('div.tc-rubi-gauche-option:not(.tc-hidden):not(.tc-hidden-rubi)');
                if (div_rubi_gauche.length > 0) {
                    var li_rubi_gauche = div_rubi_gauche.find('li.tc-active');
                    var img_rubi_gauche = li_rubi_gauche.find('input.tc-rubi-gauche-option').attr('data-imagel');
                    $('.custom-single-product-page .row-images img.attachment-rubi-gauche').attr('src', img_rubi_gauche);
                }

                // size product
                var div_size_product = section.find('div.tc-size-product-option:not(.tc-hidden)');
                if (div_size_product.length > 0) {
                    option_size = true;

                    var li_size_product = div_size_product.find('li.tc-active');
                    var size_product =  li_size_product.find('input.tc-size-product-option').val();
                    var petit = 'Petit';
                    var grand = 'Grand';
                    var moyen = 'Moyen';
                    if (size_product.indexOf(petit) != -1) {
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('grand').removeClass('moyen').addClass('petit');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('grand').removeClass('moyen').addClass('petit');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('grand').removeClass('moyen').addClass('petit');
                    } else if (size_product.indexOf(grand) != -1) {
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('petit').removeClass('moyen').addClass('grand');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('petit').removeClass('moyen').addClass('grand');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('petit').removeClass('moyen').addClass('grand');
                    } else if (size_product.indexOf(moyen) != -1) {
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('grand').removeClass('petit').addClass('moyen');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('grand').removeClass('petit').addClass('moyen');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('grand').removeClass('petit').addClass('moyen');
                    } else {
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('grand').removeClass('petit').removeClass('moyen');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('grand').removeClass('petit').removeClass('moyen');
                        $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('grand').removeClass('petit').removeClass('moyen');
                    }
                }

                if (option_size === false) {
                    $('.custom-single-product-page .image-wrap img.attachment-jewelry').removeClass('grand').removeClass('petit').removeClass('moyen');
                    $('.custom-single-product-page .image-wrap img.attachment-jewelry-droit').removeClass('grand').removeClass('petit').removeClass('moyen');
                    $('.custom-single-product-page .image-wrap img.attachment-jewelry-gauche').removeClass('grand').removeClass('petit').removeClass('moyen');
                }
            });
        });

        // add to cart
        $('.custom-single-product-page').on('click', '.single_add_to_cart_button', function(e) {
            e.preventDefault();

            $(this).parents('form.cart.tc-active').submit();
        });

        $('.custom-single-product-page').on('submit', 'form.cart.tc-active', function(e) {
            var $form = $(this);

            e.preventDefault();

            var $thisbutton = $form.find('.single_add_to_cart_button'),
                data        = $form.serialize();

            data += '&action=woodmart_ajax_add_to_cart';

            if ($thisbutton.val()) {
                data += '&add-to-cart=' + $thisbutton.val();
            }

            $thisbutton.removeClass('added not-added');
            $thisbutton.addClass('loading');

            // Trigger event
            woodmartThemeModule.$body.trigger('adding_to_cart', [
                $thisbutton,
                data
            ]);

            $.ajax({
                url     : woodmart_settings.ajaxurl,
                data    : data,
                method  : 'POST',
                success : function(response) {
                    if (!response) {
                        return;
                    }

                    var this_page = window.location.toString();

                    this_page.replace('add-to-cart', 'added-to-cart');

                    if (response.error && response.product_url) {
                        window.location = response.product_url;
                        return;
                    }

                    // Redirect to cart option
                    if (woodmart_settings.cart_redirect_after_add === 'yes') {
                        window.location = woodmart_settings.cart_url;
                    } else {

                        $thisbutton.removeClass('loading');

                        var fragments = response.fragments;
                        var cart_hash = response.cart_hash;

                        // Block fragments class
                        if (fragments) {
                            $.each(fragments, function(key) {
                                $(key).addClass('updating');
                            });
                        }

                        // Replace fragments
                        if (fragments) {
                            $.each(fragments, function(key, value) {
                                $(key).replaceWith(value);
                            });
                        }

                        // Show notices
                        var $noticeWrapper = $('.woocommerce-notices-wrapper');
                        $noticeWrapper.empty();
                        if (response.notices.indexOf('error') > 0) {
                            $noticeWrapper.append(response.notices);
                            $thisbutton.addClass('not-added');
                        } else {
                            if ('undefined' !== typeof $.fn.magnificPopup && woodmart_settings.add_to_cart_action === 'widget') {
                                $.magnificPopup.close();
                            }

                            // Changes button classes
                            $thisbutton.addClass('added');
                            // Trigger event so themes can refresh other areas
                            woodmartThemeModule.$body.trigger('added_to_cart', [
                                fragments,
                                cart_hash,
                                $thisbutton
                            ]);
                            //Show cart widget
                            if (!$('.wd-close-side').hasClass('wd-close-side-opened')) {
                                $('.wd-close-side').addClass('wd-close-side-opened');
                            }

                            if (!$('.cart-widget-side').hasClass('wd-opened')) {
                                $('.cart-widget-side').addClass('wd-opened');
                            }
                        }
                    }
                },
                error   : function() {
                    console.log('ajax adding to cart error');
                },
                complete: function() { }
            });
        });
    }
    
    // Fix: Auto-select matching item in each step to sync gallery with jewelry display
    if ($('.custom-single-product-page').length) {
        // Function to auto-select matching item in a step
        function autoSelectMatchingItem(stepSelector) {
            console.log('🔍 autoSelectMatchingItem called with:', stepSelector);
            var step = $(stepSelector);
            if (step.length) {
                console.log('🔍 Step found, processing...');
                step.find('div.tm-cell:not(.tc-hidden)').each(function () {
                    var div_active = $(this);
                    var hasActive = false;
                    var currentActiveItem = null;
                    
                    // Check if there's already an active item
                    div_active.find('li.tmcp-field-wrap').each(function () {
                        if ($(this).hasClass('tc-active')) {
                            hasActive = true;
                            currentActiveItem = $(this);
                        }
                    });
                    
                    // If no item is selected, try to find matching item based on current jewelry display
                    if (!hasActive) {
                        var currentJewelrySrc = $('.custom-single-product-page .row-images img.attachment-jewelry-gauche').attr('src');
                        var matchingItem = null;
                        
                        // Try to find item that matches current jewelry display
                        if (currentJewelrySrc && currentJewelrySrc !== '') {
                            console.log('Current jewelry src:', currentJewelrySrc);
                            div_active.find('li.tmcp-field-wrap').each(function () {
                                var itemImg = $(this).find('input').attr('data-imagel');
                                var itemImgP = $(this).find('input').attr('data-imagep');
                                
                                console.log('Checking item - data-imagel:', itemImg, 'data-imagep:', itemImgP);
                                
                                // Check both data-imagel and data-imagep
                                if (itemImg && currentJewelrySrc.includes(itemImg.split('/').pop())) {
                                    console.log('Found matching item with data-imagel');
                                    matchingItem = $(this);
                                    return false; // break
                                } else if (itemImgP && currentJewelrySrc.includes(itemImgP.split('/').pop())) {
                                    console.log('Found matching item with data-imagep');
                                    matchingItem = $(this);
                                    return false; // break
                                }
                            });
                        }
                        
                        // If no matching item found, check if this is a kaligraphe step
                        if (!matchingItem) {
                            var stepTitle = step.find('.tm-section-label').text().toLowerCase();
                            console.log('🔍 Step title:', stepTitle);
                            if (stepTitle.includes('kaligraphe') || stepTitle.includes('calligraphy')) {
                                console.log('🔍 This is a kaligraphe step!');
                                // For kaligraphe steps, try to find item based on current jewelry configuration
                                var currentJewelrySrc = $('.custom-single-product-page .row-images img.attachment-jewelry-gauche').attr('src');
                                console.log('Kaligraphe step - Current jewelry src:', currentJewelrySrc);
                                
                                if (currentJewelrySrc && currentJewelrySrc !== '') {
                                    // For kaligraphe steps, we need to find the product based on the current jewelry type
                                    // The default jewelry should correspond to "chin" type
                                    // We need to find the product with gaucheType = "chin"
                                    
                                    console.log('Kaligraphe step - Looking for matching item...');
                                    console.log('Current jewelry src:', currentJewelrySrc);
                                    
                                    // Try to find the product that matches the current jewelry configuration
                                    // Look for products with data attributes that match the current jewelry
                                    div_active.find('li.tmcp-field-wrap').each(function () {
                                        var $item = $(this);
                                        var productId = $item.find('input').attr('data-product-id');
                                        
                                        // Check if this product has the right configuration
                                        // Look for data attributes that match the current default type
                                        var dataGaucheType = $item.find('input').attr('data-jewelry-gauche-type');
                                        var currentDefaultType = $('[data-jewelry-gauche-type]').attr('data-jewelry-gauche-type');
                                        
                                        console.log('Checking item - productId:', productId, 'dataGaucheType:', dataGaucheType, 'currentDefaultType:', currentDefaultType);
                                        
                                        if (dataGaucheType === currentDefaultType) {
                                            console.log('✅ Found matching product:', productId, 'with gaucheType:', dataGaucheType);
                                            matchingItem = $item;
                                            return false; // break
                                        }
                                    });
                                    
                                    console.log('Final matchingItem:', matchingItem ? 'Found' : 'Not found');
                                }
                                
                                // If still no match, select the first one as fallback
                                if (!matchingItem) {
                                    console.log('No matching item found, selecting first one');
                                    matchingItem = div_active.find('li.tmcp-field-wrap').first();
                                }
                            } else {
                                // For other steps, select the first one
                                matchingItem = div_active.find('li.tmcp-field-wrap').first();
                            }
                        }
                        
                        if (matchingItem && matchingItem.length) {
                            matchingItem.addClass('tc-active');
                            // Trigger click event to update the display
                            matchingItem.trigger('click');
                        }
                    }
                });
            }
        }
        
        // Initialize on page load
        setTimeout(function() {
            console.log('🔍 Initializing on page load...');
            var steps = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-css:not(.tc-hidden)');
            console.log('🔍 Found steps:', steps.length);
            steps.each(function() {
                autoSelectMatchingItem(this);
            });
        }, 500);
        
        // Auto-select when step changes
        $(document).on('click', '.tc-step-by-step .tc-next-step', function() {
            setTimeout(function() {
                var currentStep = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-css:not(.tc-hidden)').last();
                console.log('🔍 Next step clicked, currentStep:', currentStep);
                autoSelectMatchingItem(currentStep);
            }, 500); // Increased delay to ensure step is fully rendered
        });
        
        // Auto-select when going back to previous step
        $(document).on('click', '.tc-step-by-step .tc-prew-step', function() {
            setTimeout(function() {
                var currentStep = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-css:not(.tc-hidden)').last();
                autoSelectMatchingItem(currentStep);
            }, 200);
        });
        
        // Auto-select when step 4 is rendered (kaligraphe step)
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    var addedNodes = Array.from(mutation.addedNodes);
                    var hasStepContent = addedNodes.some(function(node) {
                        return node.nodeType === 1 && (
                            node.id === 'step' || 
                            node.querySelector && node.querySelector('#step') ||
                            node.classList && node.classList.contains('section-panel-css')
                        );
                    });
                    
                    if (hasStepContent) {
                        setTimeout(function() {
                            console.log('🔍 Step content changed, checking for kaligraphe step...');
                            var kaligrapheStep = $('.custom-single-product-page form.cart.tc-active .tc-extra-product-options .section-panel-css:not(.tc-hidden)').last();
                            if (kaligrapheStep.length) {
                                var stepTitle = kaligrapheStep.find('.tm-section-label').text().toLowerCase();
                                if (stepTitle.includes('kaligraphe') || stepTitle.includes('calligraphy')) {
                                    console.log('🔍 Kaligraphe step detected, auto-selecting...');
                                    autoSelectMatchingItem(kaligrapheStep);
                                }
                            }
                        }, 1000);
                    }
                }
            });
        });
        
        // Start observing
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        // Auto-select matching item when user selects kaligraphe number
        $(document).on('click', 'li.tmcp-field-wrap', function() {
            var clickedItem = $(this);
            var step = clickedItem.closest('.section-panel-css');
            
            // Check if this is a kaligraphe step
            var stepTitle = step.find('.tm-section-label').text().toLowerCase();
            if (stepTitle.includes('kaligraphe') || stepTitle.includes('calligraphy')) {
                // After user selects number, sync the gallery
                setTimeout(function() {
                    autoSelectMatchingItem(step);
                }, 100);
            }
        });
    }
});